import React from "react";
import Section from "../../components/section";
import founderImage from "../../assets/founders/founder-1.jpg";
import coFounder1Image from "../../assets/founders/founder-2.jpg";
import coFounder2Image from "../../assets/founders/founder-3.jpg";
import coFounder3Image from "../../assets/founders/founder-4.jpg";
import background from "../../assets/backgrounds/landing-2.svg";

const About: React.FC = () => {
  return (
    <Section backgroundImage={background}>
      <div className="md:flex md:items-center">
        <div className="md:flex md:items-center">
          <div className="md:w-1/2 md:pr-8">
            <div className="hidden md:flex md:flex-col md:items-center md:justify-center">
              <div className="mb-8">
                <p className="text-xl font-bold text-white text-opacity-80 text-center">
                  Founder
                </p>
                <img
                  src={founderImage}
                  alt="Founder"
                  className="w-32 aspect-square rounded-full object-cover mb-2"
                />
                <p className="text-xl font-bold text-white text-opacity-80 text-center">
                  Kaylee
                </p>
              </div>
              <div className="md:grid md:grid-cols-3 md:gap-8">
                <div className="flex flex-col items-center">
                  <p className="text-xl font-bold text-white text-opacity-80 text-center mt-7">
                    Co-Founder
                  </p>
                  <img
                    src={coFounder1Image}
                    alt="Co-Founder 1"
                    className="w-32 aspect-square rounded-full object-cover mb-2"
                  />
                  <p className="text-xl font-bold text-white text-opacity-80 text-center">
                    Phylicia
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <p className="text-xl font-bold text-white text-opacity-80 text-center mt-7">
                    Co-Founder
                  </p>
                  <img
                    src={coFounder2Image}
                    alt="Co-Founder 2"
                    className="w-32 aspect-square rounded-full object-cover mb-2"
                  />
                  <p className="text-xl font-bold text-white text-opacity-80 text-center">
                    Gek Shan
                  </p>
                </div>
                <div className="flex flex-col items-center justify-center">
                  <p className="text-xl font-bold text-white text-opacity-80 text-center">
                    Business Development
                  </p>
                  <img
                    src={coFounder3Image}
                    alt="Co-Founder 3"
                    className="w-32 aspect-square rounded-full object-cover mb-2"
                  />
                  <p className="text-xl font-bold text-white text-opacity-80 text-center">
                    Rakshita
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 px-2">
            <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-center md:text-left text-white">
              Setting Sail: Rippl.sg
            </h2>
            <div className="md:hidden flex mb-8">
              <div className="grid grid-rows-3 gap-4">
                <div className="grid grid-cols-4 items-center justify-items-center">
                  <p className="text-sm font-bold text-white text-center">
                    Founder
                  </p>
                  <p className="text-sm font-bold text-white text-center">
                    Co-Founder
                  </p>
                  <p className="text-sm font-bold text-white text-center">
                    Co-Founder
                  </p>
                  <p className="text-xs font-bold text-white text-center">
                    Business development
                  </p>
                </div>

                <div className="grid grid-cols-4 items-center justify-items-center">
                  <img
                    src={founderImage}
                    alt="Founder"
                    className="w-16 aspect-square rounded-full object-cover"
                  />
                  <img
                    src={coFounder1Image}
                    alt="Co-Founder 1"
                    className="w-16 aspect-square rounded-full object-cover"
                  />
                  <img
                    src={coFounder2Image}
                    alt="Co-Founder 2"
                    className="w-16 aspect-square rounded-full object-cover"
                  />
                  <img
                    src={coFounder3Image}
                    alt="Co-Founder 3"
                    className="w-16 aspect-square rounded-full object-cover"
                  />
                </div>

                <div className="grid grid-cols-4 items-center justify-items-center">
                  <p className="text-sm font-bold text-white text-center">
                    Kaylee
                  </p>
                  <p className="text-sm font-bold text-white text-center">
                    Phylicia
                  </p>
                  <p className="text-sm font-bold text-white text-center">
                    Gek Shan
                  </p>
                  <p className="text-sm font-bold text-white text-center">
                    Rakshita
                  </p>
                </div>
              </div>
            </div>
            <p className="text-white text-base font-semibold md:text-2xl text-center md:text-left">
              Origins
            </p>
            <p className="text-white text-base md:text-xl text-center md:text-left mb-5">
              rippl.sg was founded by Kaylee, Phylicia, Gek Shan, and Rakshita,
              inspired by their voyage with the US non-profit Redefy. They
              launched rippl.sg in Singapore to cultivate social cohesion
              through creative media and community events.
            </p>
            <p className="text-white text-base font-semibold md:text-2xl text-center md:text-left">
              Voyage
            </p>
            <p className="text-white text-base md:text-xl text-center md:text-left mb-5">
              In 2023, rippl.sg secured a grant via Youth Action Challenge to
              produce a video series with XI Productions and host the first
              Close Circles, focusing on dementia awareness in 2024. We're
              committed to building community bonds and sparking change through
              captivating storytelling.
            </p>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default About;
